export default __webpack_public_path__ + "static/media/alianzas_background.9750ca56.png";